import { Injectable } from '@angular/core';
import { TransformationDto } from '@osos/shared/api';
import { TransformationPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';

@Injectable()
export class TransformationParserV1Service extends ParserBase<
  TransformationDto,
  TransformationPresenterModel
> {
  constructor() {
    super(TransformationDto, TransformationPresenterModel, 1);
  }
  getPresenterModel(
    model: Partial<TransformationDto>
  ): TransformationPresenterModel {
    return null;
  }

  getDataModel(presenter: TransformationPresenterModel): TransformationDto {
    return {
      field: presenter.field,
      type: presenter.type,
      value: presenter.value,
    };
  }
}
